/**
 * Represents a tool that utilizes an iframe.
 * This class initializes with an entry object containing properties like description, iframeTool, and icon.
 */
import RepositoryEntry from './RepositoryEntry';

class UniversalCanvasPalette extends RepositoryEntry {
    /**
     * Constructs an instance of IframeTool.
     */
    constructor(entry, $injector) {
        super(entry, $injector);
    
        this.accessables({
            'name'  : String,
            'items' : Object,
        });

        this.readables({
            'type'  : String,
        });
    }
}

export default UniversalCanvasPalette;